import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormikContext } from "formik";
import { isEqual } from "lodash";
var FormikValuesListener = function (_a) {
    var values = _a.values, setValues = _a.setValues, submit = _a.submit, setSubmit = _a.setSubmit;
    var formikContext = useFormikContext();
    useEffect(function () {
        if (!isEqual(formikContext.values, values)) {
            setValues(formikContext.values);
        }
    }, [formikContext.values, values]);
    useEffect(function () {
        if (setSubmit && submit) {
            setSubmit(false);
            formikContext.submitForm();
        }
    }, [submit]);
    return _jsx(_Fragment, {});
};
export default FormikValuesListener;
